import React from 'react';
//@ts-ignore
import * as homeStyle from '../styles/home.module.scss';
import { StaticImage } from "gatsby-plugin-image"

export const works = [
  {
    name: "PlayGroup",
    stack: ["React", "NodeJS", "WebSocket", "Typescript"],
    component: <StaticImage
      className={homeStyle.workImg}
      src='../images/work5.png'
      alt="work5" />,
    linkLive: "https://playgroup.netlify.app/",
    linkCode: "https://github.com/Kev2000-Github/PlayGroup"
  },
  {
    name: "MusicakLive",
    stack: ["React", "SASS"],
    component: <StaticImage
      className={homeStyle.workImg}
      src='../images/work6.png'
      alt="work6" />,
    linkLive: "https://musicaklive.netlify.app/"
  },
  {
    name: "Anime Web Scrapper",
    stack: ["React", "NodeJS", "Typescript"],
    component: <StaticImage
      className={homeStyle.workImg}
      src="../images/work2.png"
      alt="work2" />,
    linkLive: "https://naughty-raman-a4b400.netlify.app/",
    linkCode: "https://github.com/Kev2000-Github/anime-webscrapper-frontend"
  },
  {
    name: "Pokedex",
    stack: ["React", "NodeJS"],
    component: <StaticImage
      className={homeStyle.workImg}
      src="../images/work1.png"
      alt="work1" />,
    linkLive: "https://condescending-lamport-65eb62.netlify.app/",
    linkCode: "https://github.com/Kev2000-Github/Pokedex-Project"
  },
  {
    name: "ZonaFranca",
    stack: ["HTML", "CSS", "Webpack"],
    component: <StaticImage
      className={homeStyle.workImg}
      src='../images/work3.png'
      alt="work3" />,
    linkLive: "https://flamboyant-jackson-0184ef.netlify.app/",
  },
  {
    name: "Simple Calculator",
    stack: ["HTML", "CSS", "Webpack"],
    component: <StaticImage
      className={homeStyle.workImg}
      src='../images/work4.png'
      alt="work4" />,
    linkLive: "https://kev2000-github.github.io/calculator/",
    linkCode: "https://github.com/Kev2000-Github/calculator"
  }
]